import axios from "axios";
import { APP_URL, USER_API_URL, config } from "./serviceConstants";
import { getParams } from "../utils/helpers";

const {
  seniorId,
  seniorUuid,
  reportId,
  providerId,
  adminId,
  clientId,
  moduleId,
} = getParams();

const getJwtPayload = (token) => {
  try {
    if (!token) return null;
    const payload = token.split(".")[1];
    if (!payload) return null;
    const normalizedPayload = payload.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(normalizedPayload)
        .split("")
        .map((char) => "%" + char.charCodeAt(0).toString(16).padStart(2, "0"))
        .join(""),
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
};

const getLoggedInUserId = () => {
  const params = getParams();
  const payload = getJwtPayload(params.accessToken);
  return params.userId || payload?.sub || payload?.username || params.staffId;
};
export const getRomReport = async () => {
  const appURL =
    APP_URL +
    "seniors/" +
    seniorId +
    "/events/" +
    reportId +
    "/summary?module=5";
  return axios.get(appURL, config);
};

export const usergetInfo = async () => {
  const appURL = APP_URL + "seniors/" + seniorUuid;
  return axios.get(appURL, config);
};

export const getRomHistory = async (pageNumber, pageSizeNumber, filterData) => {
  const appURL =
    APP_URL +
    "v3/" +
    "seniors/" +
    seniorUuid +
    "/romKnee/" +
    "events/" +
    `history?page=${pageNumber}&pageSize=${pageSizeNumber}&filter=${filterData}`;
  return axios.get(appURL, config);
};

export const getRecipients = async () => {
  const appURL = APP_URL + "v5/report/recipient";
  return axios.get(appURL, config);
};

export const getLoggedInUserDetails = async () => {
  const userId = getLoggedInUserId();
  if (!userId) {
    return Promise.resolve({ data: { data: null } });
  }
  const appURL = USER_API_URL + "users/" + userId;
  return axios.get(appURL, config);
};

export const createRecipient = async ({ firstname, lastname, email }) => {
  const appURL = APP_URL + "v5/report/recipient";
  return axios.post(appURL, { firstname, lastname, email }, config);
};

export const updateRecipient = async ({ id, firstname, lastname, email }) => {
  const appURL = APP_URL + "v5/report/recipient/" + id;
  return axios.patch(appURL, { firstname, lastname, email }, config);
};

export const deleteRecipient = async (id) => {
  const appURL = APP_URL + "v5/report/recipient/" + id;
  return axios.delete(appURL, config);
};

export const sendPdf = async (request) => {
  const appURL = APP_URL + "v5/report/send/" + seniorUuid;
  return axios.post(appURL, request, config);
};

export const getCustomTheme = async () => {
  const appURL =
    APP_URL +
    `app/theme?providerId=${providerId}&adminId=${adminId}&clientId=${clientId}`;
  return axios.get(appURL, config);
};

export const getSummary = async (number) => {
  const appURL =
    APP_URL +
    `v3/seniors/${seniorUuid}/events/${reportId}/summary?moduleId=${number}`;
  return axios.get(appURL, config);
};

export const addComments = async (request, reportID) => {
  const appURL = APP_URL + `seniors/${seniorUuid}/reports/${reportID}`;
  return axios.put(appURL, request, config);
};

export const getHistory = async (type, filterField, filterUpto) => {
  const appURL =
    APP_URL +
    `seniors/${seniorUuid}/events?type=${type}&filterField=${filterField}&filterUpto=${filterUpto}`;
  return axios.get(appURL, config);
};

export const getV5MetricHistory = async (type, filterField, filterUpto) => {
  const appURL =
    APP_URL +
    `v5/seniors/${seniorUuid}/events/metric?moduleId=${
      moduleId || 1
    }&type=${type}&filterField=${filterField}&filterUpto=${filterUpto}`;
  return axios.get(appURL, config);
};

export const getPdfHistory = async (moduleId, limit) => {
  const appURL =
    APP_URL +
    `seniors/${seniorUuid}/events/summary?moduleId=${moduleId}&limit=${limit}`;
  return axios.get(appURL, config);
};

export const getV5LatestReportSummary = async () => {
  const appURL =
    APP_URL +
    `v5/seniors/${seniorUuid}/events/latest/summary?moduleId=${moduleId}`;
  return axios.get(appURL, config);
};

export const getV5ReportSummary = async () => {
  if (!reportId) {
    return getV5LatestReportSummary();
  }
  const appURL =
    APP_URL +
    `v5/seniors/${seniorUuid}/events/${reportId}/summary?moduleId=${moduleId}`;
  return axios.get(appURL, config);
};
